import React, { useEffect, useState } from 'react';

function fmtRemaining(ms) {
  const m = Math.max(0, Math.round(ms / 60000));
  if (m < 1) return 'less than a minute';
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  if (h < 48) return m % 60 ? `${h} h ${m % 60} min` : `${h} h`;
  return `${Math.round(h / 24)} days`;
}

// Shown ONLY on shared (90-day) links, viewer-facing: one quiet read-only
// line. The in-app surface renders no bar at all — the app mints a fresh
// token on every open, so "extend"/"revoke" were dead weight there (the
// old owner bar with those buttons is intentionally gone).
export default function TokenBar({ meta }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick(t => t + 1), 30000);
    return () => clearInterval(id);
  }, []);

  if (!meta || meta.kind !== 'share') return null;
  const remaining = new Date(meta.expires_at).getTime() - Date.now();
  return (
    <div className="token-bar" role="status">
      <span className="token-bar-timer">
        {remaining <= 0 ? 'This shared report has expired'
          : <>Shared report · available for <strong>{fmtRemaining(remaining)}</strong></>}
      </span>
    </div>
  );
}
